import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import i18n from '@/i18n'

Vue.use(VueRouter)

export const routes = [
  {
    path: '*',
    redirect: { name: 'Home' },
    show: false,
  },
  {
    path: '/home',
    name: 'Home',
    icon: 'mdi-home-variant',
    title: 'Página Inicial',
    guestAccess: true,
    show: true,
    component: () => import('@/views/home/Index'),
  },
  {
    path: '/login',
    name: 'Login',
    show: false,
    component: () => import('@/views/login/Index'),
  },
  {
    path: '/pais',
    name: 'Pais',
    icon: 'mdi-flag',
    title: 'Paises',
    show: true,
    children: [
      {
        path: 'register',
        name: 'pais.register',
        component: () => import('@/views/country/Register'),
      },
    ],
    component: () => import('@/views/country/Index'),
  },
  {
    path: '/taxa-entrega',
    name: 'Delivery',
    icon: 'mdi-truck',
    title: 'Taxas Entrega',
    show: true,
    children: [
      {
        path: 'register',
        name: 'delivery.register',
        component: () => import('@/views/delivery-fee/Register'),
      },
    ],
    component: () => import('@/views/delivery-fee/Index'),
  },
  {
    path: '/cidade',
    name: 'Cidade',
    icon: 'mdi-city',
    title: 'Cidades',
    show: true,
    children: [
      {
        path: 'register',
        name: 'cidade.register',
        component: () => import('@/views/city/Register'),
      },
    ],
    component: () => import('@/views/city/Index'),
  },
  {
    path: '/item',
    name: 'Item',
    icon: 'mdi-cube-outline',
    title: 'Produtos/Serviços',
    show: true,
    component: () => import('@/views/item/Index'),
  },
  {
    path: '/empresa',
    name: 'Empresa',
    icon: 'mdi-office-building',
    title: 'Empresas',
    show: true,
    children: [
      {
        path: 'register',
        name: 'empresa.register',
        component: () => import('@/views/company/Register'),
      },
    ],
    component: () => import('@/views/company/Index'),
  },
  {
    path: '/obra',
    name: 'Obra',
    icon: 'mdi-account-hard-hat',
    title: 'Obras',
    show: true,
    children: [
      {
        path: 'register',
        name: 'obra.register',
        component: () => import('@/views/construction/Register'),
      },
    ],
    component: () => import('@/views/construction/Index'),
  },
  {
    path: '/plano-contas',
    name: 'PlanoContas',
    icon: 'mdi-finance',
    title: 'Plano Contas',
    show: true,
    children: [
      {
        path: 'register',
        name: 'plano-contas.register',
        component: () => import('@/views/account/Register'),
      },
    ],
    component: () => import('@/views/account/Index'),
  },
  {
    path: '/usuarios',
    name: 'Usuario',
    icon: 'mdi-account-group',
    title: 'Usuários',
    show: true,
    component: () => import('@/views/user/Index'),
    children: [
      {
        path: 'register',
        name: 'usuario.register',
        component: () => import('@/views/user/Register'),
      },
    ],
  },
  {
    path: '/marca',
    name: 'Marca',
    icon: 'mdi-watermark',
    title: 'Marcas',
    show: true,
    component: () => import('@/views/brand/Index'),
    children: [
      {
        path: 'register',
        name: 'marca.register',
        component: () => import('@/views/brand/Register'),
      },
    ],
  },
  {
    path: '/fabricante',
    name: 'Fabricante',
    icon: 'mdi-factory',
    title: 'Fabricantes',
    show: true,
    component: () => import('@/views/manufacturer/Index'),
    children: [
      {
        path: 'register',
        name: 'fabricante.register',
        component: () => import('@/views/manufacturer/Register'),
      },
    ],
  },
  {
    path: '/grupo',
    name: 'Grupo',
    icon: 'mdi-group',
    title: 'Grupos de Itens',
    show: true,
    component: () => import('@/views/group/Index'),
    children: [
      {
        path: 'register',
        name: 'itemsGroup.register',
        component: () => import('@/views/group/Register'),
      },
    ],
  },
  {
    path: '/cambio',
    name: 'Cambio',
    icon: 'mdi-currency-usd',
    title: 'Câmbios',
    show: true,
    component: () => import('@/views/currency/Index'),
    children: [
      {
        path: 'register',
        name: 'currency.register',
        component: () => import('@/views/currency/Register'),
      },
    ],
  },
  {
    path: '/veiculo',
    name: 'Veiculo',
    icon: 'mdi-car',
    title: 'Veículos',
    show: true,
    component: () => import('@/views/vehicle/Index'),
    children: [
      {
        path: 'register',
        name: 'vehicle.register',
        component: () => import('@/views/vehicle/Register'),
      },
    ],
  },
  {
    path: '/measurement-units',
    name: 'measurementUnits',
    icon: 'mdi-tape-measure',
    title: 'Unidades de Medidas',
    show: true,
    component: () => import('@/views/measurement-units/Index'),
    children: [
      {
        path: 'register',
        name: 'measurementUnits.register',
        component: () => import('@/views/measurement-units/Register'),
      },
    ],
  },
  {
    path: '/payment-conditions',
    name: 'paymentConditions',
    icon: 'mdi-credit-card-outline',
    title: 'Condições de Pagamento',
    show: true,
    component: () => import('@/views/payment-conditions/Index'),
    children: [
      {
        path: 'register',
        name: 'paymentConditions.register',
        component: () => import('@/views/payment-conditions/Register'),
      },
    ],
  },
  {
    path: '/departamentos',
    name: 'Departamento',
    icon: 'mdi-store',
    title: 'Departamentos',
    show: true,
    component: () => import('@/views/departament/Index'),
    children: [
      {
        path: 'register',
        name: 'departament.register',
        component: () => import('@/views/departament/Register'),
      },
    ],
  },
  {
    path: '/pdv',
    name: 'PDV',
    icon: 'mdi-cart',
    title: 'PDV',
    guestAccess: true,
    show: true,
    children: [
      {
        path: 'register-company',
        name: 'pdv.register.company',
        guestAccess: true,
        component: () => import('@/views/company/QuickRegister'),
      },
    ],
    component: () => import('@/views/pdv/balcao/Index'),
  },
  {
    path: '/empresa-listas',
    name: 'EmpresaListas',
    icon: 'mdi-view-list',
    title: 'Lista de Produtos de Empresas',
    show: true,
    component: () => import('@/views/company-list/Index'),
    children: [
      {
        path: 'register',
        name: 'company-list.register',
        component: () => import('@/views/company-list/Register'),
      },
    ],
  },
  {
    path: '/remote-company',
    name: 'RemoteCompany',
    show: false,
    component: () => import('@/views/company/RemoteRegister'),
  },
  {
    path: '/system',
    name: 'System',
    icon: 'mdi-desktop-classic',
    title: 'Sistema',
    show: false,
    component: () => import('@/views/system/Index'),
  },
  {
    path: '/integracao',
    name: 'Integracao',
    icon: 'mdi-vector-union',
    title: 'Integração',
    show: true,
    component: () => import('@/views/integration/Index'),
  },
  {
    path: '/integracao/iset',
    name: 'Integracao.iset',
    component: () => import('@/views/integration/iset/Index'),
  },
  {
    path: '/integracao/tray',
    name: 'Integracao.tray',
    component: () => import('@/views/integration/tray/Index'),
  },
  {
    path: '/integracao/ifood',
    name: 'Integracao.ifood',
    component: () => import('@/views/integration/ifood/Index'),
  },
  {
    path: '/integracao/ifood/gerenciador',
    name: 'ifood.gerenciador',
    show: false,
    component: () => import('@/views/integration/ifood/Gerenciador'),
  },
  {
    path: '/categories',
    name: 'Categories',
    icon: 'mdi-shape',
    title: 'Categorias',
    show: true,
    children: [
      {
        path: 'register',
        name: 'categories.register',
        component: () => import('@/views/category/Register'),
      },
    ],
    component: () => import('@/views/category/Index'),
  },
]

const allowedGuestRoutes = ['Home', 'PDV']

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  const authUser = store.state.authModule.authUser

  if (to.name == 'RemoteCompany') {
    if (!authUser) {
      next()
    } else {
      Vue.toasted.error(
        `Para URL: "${to.path}" ${i18n.t('messages.cannotAuth')}`,
        { duration: null }
      )
      next({ name: 'Home' })
    }
  } else {
    if (authUser && !store.state.authModule.tokenInvalid) {
      try {
        let response = await store.dispatch('authModule/checkAuthToken')
        if (response) {
          if (store.state.systemModule.systemList.length <= 0)
            await store.dispatch('systemModule/getSystems')

          /*
           * recuperar a filial e suas flags
           * Usuário convidado não verifica flags no front
           */
          await store.dispatch('systemModule/getSystem', authUser.filial)
        }
      } catch (error) {
        Vue.toasted.error(error, { duration: null })
        return
      }
    }

    let tokenIsInvalid = store.state.authModule.tokenInvalid
    let title = process.env.VUE_APP_TITLE + ' | ' + 'Gestão WEB'
    document.title = title
    if (to.name !== 'Login' && !authUser) {
      Vue.toasted.error(i18n.t('login.routeValidation'))
      next({ name: 'Login' })
    } else if (to.name == 'Login' && authUser) {
      next({ name: 'Home' })
    } else if (
      authUser &&
      authUser.guest &&
      allowedGuestRoutes.lastIndexOf(to.name) == -1
    ) {
      next({ name: 'Home' })
    } else if (
      tokenIsInvalid &&
      to.name !== 'Login' &&
      to.name !== router.history.pending.name
    ) {
      if (from.name == null) {
        router.replace({ name: to.name })
      } else next({ name: from.name })
    } else {
      next()
    }
  }
})

export default router
